import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import BackofficeLogin from "@/pages/BackofficeLogin";
import CoachDashboard from "@/pages/CoachDashboard";

const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-4 border-emerald-600 border-t-transparent animate-spin" />
    </div>
  );
}

function CoachRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <Spinner />;
  if (user && user.role === "admin") return <Navigate to="/backoffice" replace />;
  if (!user) return <Login />;
  return <CoachDashboard />;
}

function BackofficeRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <Spinner />;
  if (user && user.role === "coach") return <Navigate to="/" replace />;
  if (!user) return <BackofficeLogin />;
  return <Suspense fallback={<Spinner />}><AdminDashboard /></Suspense>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CoachRoute />} />
            <Route path="/backoffice" element={<BackofficeRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
